import script from "./HeaderNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderNotifications.vue?vue&type=script&setup=true&lang=js"

import "./HeaderNotifications.vue?vue&type=style&index=0&id=5eb2d8be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb2d8be"]])

export default __exports__